//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import packageDocumentsQuery from '~/apollo/queries/documents/package-documents'
import filterResults from '~/mixins/filter-results'

export default {
  mixins: [filterResults],
  data () {
    return {
      fetched: false,
      fetchedSoftware: false
    }
  },
  props: {
    packageId: String
  },
  apollo: {
    packageDocuments: {
      prefetch: true,
      query: packageDocumentsQuery,
      result ({ data, loading, networkStatus }) {
        this.fetched = true
      },
      error (error) {
        console.log(error)
        this.fetched = true
      }
    }
  },
  async fetch () {
    this.software = await this.$http.$get(this.$config.motecOnlineUrl + '/ResourceDownload/ResourcesForProduct?type=Software&products=' + encodeURI('targeted package'))
      .then((response) => {
        this.fetchedSoftware = true
        return response
      })
      .catch((e) => {
        console.log(e.toJSON())
        this.fetchedSoftware = true
      })
  },
  fetchOnServer: false,
  computed: {
    subcategoriesAndDocuments () {
      const ret = []
      const uploads = []
      if (this.packageDocuments) {
        this.packageDocuments.forEach((subcategory) => {
          let retSubcategory = ret.find(el => el.name === subcategory.name)
          if (!retSubcategory) {
            ret.push({ name: subcategory.name, files: [] })
            retSubcategory = ret[ret.length - 1]
          }
          subcategory.files.forEach((file) => {
            if (file.targeted_packages.find(el => el.documentId === this.packageId) && !uploads.find(el => el === file.file.url)) {
              const files = retSubcategory.files
              files.push(file)
              uploads.push(file.file.url)
            }
          })
        })
        return ret
      } else {
        return null
      }
    }
  }
}
